var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade modal-upload",
      attrs: {
        id: "deleteDOC",
        "data-keyboard": "false",
        "data-backdrop": "static"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading == true,
                  expression: "(loading == true)"
                }
              ],
              staticClass: "loading-backdrop"
            },
            [_c("div", { staticClass: "loading" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "data-dismiss": "modal" }
              },
              [_vm._v("×")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "center-modal" }, [
              _c(
                "div",
                {
                  staticClass:
                    "center-ttl font300 d-flex justify-content-center"
                },
                [
                  _c("i", { staticClass: "icon-trash-g mr-2 mt-1" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "font500 text-pink" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("doc.delete.title")) +
                        "\n                        "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.alert_error
                ? _c(
                    "div",
                    {
                      staticClass: "error-message",
                      attrs: { "data-vv-scope": "s1" }
                    },
                    [
                      _c("div", { staticClass: "d-flex" }, [
                        _c("i", { staticClass: "icon-warning mr-2" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "errror-txt" }, [
                          _c("p", { staticClass: "fs-14 text-red font600" }, [
                            _vm._v(_vm._s(_vm.$t("error.title")))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "fs-14 text-red font600" }, [
                            _vm._v(_vm._s(_vm.alert_error))
                          ])
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.deleteObj.ids.length == 1 && _vm.alert_error == ""
                ? _c("div", { attrs: { "data-vv-scope": "s2" } }, [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-center" },
                      [
                        _c("div", { staticClass: "pr-2 w-165" }, [
                          _c(
                            "button",
                            {
                              ref: "buttonDeleteDOC",
                              staticClass: "btn btn-pink-53 w-100",
                              attrs: { disabled: _vm.disabled, type: "button" },
                              on: { click: _vm.deleteDOC }
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("button.ok")) +
                                  "\n                                "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pl-2 w-165" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-gray-53 w-100",
                              attrs: {
                                disabled: _vm.disabled,
                                "data-dismiss": "modal",
                                type: "button"
                              }
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("button.cancel")) +
                                  "\n                                "
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ])
                : _c("div", [
                    this.deleteObj.ids.length <= 0
                      ? _c(
                          "div",
                          {
                            staticClass: "txc",
                            attrs: { "data-vv-scope": "s3" }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("doc.general.no_select")) +
                                "\n                        "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "d-flex justify-content-center mt-4 pt-4"
                      },
                      [
                        _c("div", { staticClass: "pl-2 w-165" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-pink-53 w-100",
                              attrs: { "data-dismiss": "modal", type: "button" }
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("button.ok")) +
                                  "\n                                "
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59974e8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59974e8e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/admin/DOCManagement/Delete.vue
// module id = null
// module chunks = 